import React, { useContext } from "react";
import { extractDatesLabel } from "gatsby-frontend";
import { Typography, Box } from "@mui/material";
import { SiteContext } from "gatsby-frontend/src/Site";
import { findRestrictionMessage } from "gatsby-frontend";

function Date({ dates, single, variant = "overline", format = "D", sx = {} }) {
	let label = extractDatesLabel(dates, format);
	const { isRestricted } = useContext(SiteContext);
	const msg = single ? findRestrictionMessage(isRestricted) : "";
	return (
		<Typography
			component="time"
			variant={variant}
			sx={(theme) => ({
				fontSize: single ? "1rem" : "0.8rem",
				opacity: 0.7,
				marginBottom: single ? theme.spacing(1) : 0,
				display: "block",
				lineHeight: 1.5,
				...sx,
			})}
		>
			{label}
			<Typography
				component="span"
				sx={{
					color: msg[1],
					display: "inline-block",
					paddingLeft: "0.5rem",
					fontSize: "100%",
				}}
			>
				{msg[0]}
			</Typography>
		</Typography>
	);
}

export default Date;
